"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsNetworkClient = exports.parseWsResponseRaw = exports.EWsEventsTypes = exports.EWebSocketClientStatus = exports.MESSAGE_UPDATE_INTERVAL = exports.LISTEN_KEY_REFRESH_INTERVAL = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const formatter_1 = require("./formatter");
const lossless_json_1 = require("lossless-json");
const binance_1 = require("../types/binance");
exports.LISTEN_KEY_REFRESH_INTERVAL = 1800000;
exports.MESSAGE_UPDATE_INTERVAL = 100;
// declare global {
//     interface Window {
//         send: any
//         sockets: any[]
//     }
// }
var EWebSocketClientStatus;
(function (EWebSocketClientStatus) {
    EWebSocketClientStatus["UNINITIALIZED"] = "UNINITIALIZED";
    EWebSocketClientStatus["LOADING"] = "LOADING";
    EWebSocketClientStatus["ACTIVE"] = "ACTIVE";
    EWebSocketClientStatus["DEACTIVATED"] = "DEACTIVATED";
    EWebSocketClientStatus["ERROR"] = "ERROR";
})(EWebSocketClientStatus = exports.EWebSocketClientStatus || (exports.EWebSocketClientStatus = {}));
var EWsEventsTypes;
(function (EWsEventsTypes) {
    EWsEventsTypes["CONNECTION_ESTABLISHED"] = "CONNECTION_ESTABLISHED";
    EWsEventsTypes["MESSAGE_RECIEVED"] = "MESSAGE_RECIEVED";
    EWsEventsTypes["CONNECTION_BROKEN"] = "CONNECTION_BROKEN";
    EWsEventsTypes["CONNECTION_DISABLED"] = "CONNECTION_DISABLED";
})(EWsEventsTypes = exports.EWsEventsTypes || (exports.EWsEventsTypes = {}));
var EWsMethodTypes;
(function (EWsMethodTypes) {
    EWsMethodTypes["SUBSCRIBE"] = "SUBSCRIBE";
    EWsMethodTypes["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    EWsMethodTypes["LIST_SUBSCRIPTIONS"] = "LIST_SUBSCRIPTIONS";
    EWsMethodTypes["SET_PROPERTY"] = "SET_PROPERTY";
    EWsMethodTypes["GET_PROPERTY"] = "GET_PROPERTY";
})(EWsMethodTypes || (EWsMethodTypes = {}));
// parse long numeric values
const jsonParser = (event) => {
    var _a, _b, _c;
    const jsonParsed = JSON.parse(event);
    if (jsonParsed.e === binance_1.EWsBinanceSpotEventsTypes.executionReport) {
        const customParsed = (0, lossless_json_1.parse)(event);
        return Object.assign(Object.assign({}, jsonParsed), { i: ((_a = customParsed === null || customParsed === void 0 ? void 0 : customParsed.i) === null || _a === void 0 ? void 0 : _a.value) || '' });
    }
    else if (jsonParsed.e === binance_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE) {
        const customParsed = (0, lossless_json_1.parse)(event);
        return Object.assign(Object.assign({}, jsonParsed), { o: Object.assign(Object.assign({}, jsonParsed.o), { i: ((_c = (_b = customParsed === null || customParsed === void 0 ? void 0 : customParsed.o) === null || _b === void 0 ? void 0 : _b.i) === null || _c === void 0 ? void 0 : _c.value) || '' }) });
    }
    else
        return jsonParsed;
};
const parseWsResponseRaw = (event) => {
    if (typeof event === 'string') {
        const parsedEvent = jsonParser(event);
        if (parsedEvent.data) {
            if (typeof parsedEvent.data === 'string') {
                return (0, exports.parseWsResponseRaw)(parsedEvent.data);
            }
            return parsedEvent.data;
        }
    }
    if (event === null || event === void 0 ? void 0 : event.data) {
        return jsonParser(event.data);
    }
    return event;
};
exports.parseWsResponseRaw = parseWsResponseRaw;
class WsNetworkClient {
    constructor(params) {
        this._status = EWebSocketClientStatus.UNINITIALIZED;
        this._messages = [];
        this.setStatus(EWebSocketClientStatus.LOADING);
        if (this.constructor === WsNetworkClient) {
            this.setStatus(EWebSocketClientStatus.ERROR);
            throw new Error("Abstract classes can't be instantiated.");
        }
        const { baseUrl, wsUrl, socket } = params;
        this._emitter = new eventemitter3_1.default();
        this._baseUrl = baseUrl;
        this._wsUrl = wsUrl;
        this._socket = socket;
        this.initSocketListeners();
    }
    static initSocket(wsUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const socket = new WebSocket(wsUrl);
            // if (window.sockets === undefined) window.sockets = []
            // window.sockets[window.sockets.length] = socket
            return new Promise(resolve => {
                socket.onopen = () => {
                    resolve(socket);
                };
            });
        });
    }
    initSocketListeners() {
        var _a;
        if (this._socket.OPEN)
            this.setStatus(EWebSocketClientStatus.ACTIVE);
        //window.send = (event: MessageEvent) => {
        //  this._messages.push(...WsFormatter.format([parseWsResponseRaw(event)]).parsed)
        //}
        this._socket.onerror = (event) => {
            var _a;
            this.setStatus(EWebSocketClientStatus.ERROR);
            (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.emit(EWsEventsTypes.CONNECTION_BROKEN, event);
        };
        this._socket.onmessage = (event) => {
            this._messages.push(...formatter_1.WsFormatter.format([(0, exports.parseWsResponseRaw)(event)]).parsed);
        };
        this._socket.onclose = (event) => {
            var _a;
            (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.emit(EWsEventsTypes.CONNECTION_BROKEN, event);
        };
        (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.emit(EWsEventsTypes.CONNECTION_ESTABLISHED);
    }
    handleSocketClose(event) {
        var _a;
        if (this.getStatus() !== EWebSocketClientStatus.DEACTIVATED)
            (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.emit(EWsEventsTypes.CONNECTION_BROKEN, event);
    }
    removeSocketListeners() {
        this._socket.onopen = null;
        this._socket.onerror = null;
        this._socket.onmessage = null;
        this._socket.onclose = null;
    }
    setStatus(status) {
        this._status = status;
    }
    subscribeStream(params) {
        if (this._status !== EWebSocketClientStatus.ACTIVE)
            return;
        const id = new Date().getTime();
        const message = {
            method: EWsMethodTypes.SUBSCRIBE,
            params,
            id,
        };
        this.sendMessage(message);
        return id;
    }
    unsubscribeStream(params) {
        if (this._status !== EWebSocketClientStatus.ACTIVE)
            return;
        const id = new Date().getTime();
        const message = {
            method: EWsMethodTypes.UNSUBSCRIBE,
            params,
            id,
        };
        this.sendMessage(message);
        return id;
    }
    sendMessage(message) {
        if (this._status !== EWebSocketClientStatus.ACTIVE)
            return;
        this._socket.send(JSON.stringify(message));
    }
    getStatus() {
        return this._status;
    }
    emitMessage() {
        if (!Boolean(this._messages.length))
            return;
        // clears message queue and sends events
        const msg = this._messages.splice(0);
        // TODO: filter only known events
        Boolean(msg.length) && this._emitter.emit(EWsEventsTypes.MESSAGE_RECIEVED, msg);
        return msg;
    }
    on(eventName, callback, context) {
        this._emitter.on(eventName, callback, context);
    }
    off(eventName, callback, context) {
        this._emitter.off(eventName, callback, context);
    }
    initQueue(messageUpdateInterval = exports.MESSAGE_UPDATE_INTERVAL) {
        if (this._queueInterval !== undefined)
            return;
        this._queueInterval = setInterval(() => this.emitMessage(), messageUpdateInterval);
    }
    stopQueue() {
        clearInterval(this._queueInterval);
        this._queueInterval = undefined;
    }
    deactivate() {
        var _a;
        this.removeSocketListeners();
        this.setStatus(EWebSocketClientStatus.DEACTIVATED);
        this._socket.close();
        this.stopQueue();
        (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.emit(EWsEventsTypes.CONNECTION_DISABLED);
        this.emitMessage();
    }
}
exports.WsNetworkClient = WsNetworkClient;
